// extracted by mini-css-extract-plugin
module.exports = {"Content":"_2VY3JOfZNy9KVAiewzwV4Z"};